import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth, RequirePasswordChange, RequireRole } from "./auth/Guards";
import AppShell from "./layout/AppShell";

import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import Verify from "./pages/Verify";
import Register from "./pages/Register";
import Admin from "./pages/Admin";
import Superadmin from "./pages/Superadmin";

export default function App() {
  return (
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route element={<RequireAuth />}>
              <Route element={<AppShell />}>
                <Route index element={<Verify />} />
                <Route path="/register" element={<Register />} />

                <Route element={<RequireRole minRole={1} />}>
                  <Route path="/admin" element={<Admin />} />
                </Route>

                <Route element={<RequireRole minRole={2} />}>
                  <Route path="/superadmin" element={<Superadmin />} />
                </Route>

                <Route element={<RequirePasswordChange />}>
                  <Route path="/change-password" element={<ChangePassword />} />
                </Route>
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
  );
}
